import { createAsyncThunk } from '@reduxjs/toolkit';

import { partnerAPI } from '@/modules/partner/api';
import { TUpdateContactInfoForm } from '@/modules/partner/model';
import { namespace } from '@/modules/partner/namespace';
import { getPartner } from '@/modules/partner/store/selectors';
import type { RootState } from '@/root-store';
import { ThunkResult } from '@/shared/actions/thunk-result';
import { ISubmitFormResult } from '@/shared/models/formSubmit';
import { getPhoneFromCodeAndNumber } from '@/shared/utils/phoneUtils';

import { updatePartner } from '../actions';

let lastRequestId: string | undefined;

const updateContactInfo = createAsyncThunk<
  ThunkResult<ISubmitFormResult<TUpdateContactInfoForm>>,
  TUpdateContactInfoForm
>(`${namespace}/submit-contact-info`, async (formValues, { dispatch, requestId, getState }) => {
  try {
    if (lastRequestId !== undefined) {
      return { isAlreadyExecuted: true };
    }

    lastRequestId = requestId;

    const partner = getPartner(getState() as RootState);

    const phone = getPhoneFromCodeAndNumber({
      code: formValues.phoneCode,
      number: formValues.phoneNumber,
    });

    const result = await partnerAPI.updateContactInfo({ ...partner, phone });

    await dispatch(
      updatePartner({
        phone,
      }),
    );

    return {
      isSucceed: true,
      result,
    };
  } finally {
    lastRequestId = undefined;
  }
});

export { updateContactInfo };
